import React from 'react'

export const PDFEmbed: React.FC<{ file: string }> = ({ file }) => {
  const url = file.indexOf('#toolbar=0') === -1 ? `${file}#toolbar=0` : file
  return <iframe src={url} style={{ height: '665px' }}></iframe>
}
